<template>
    <main class='main-content'>
        <router-view :key="$route.fullPath"/>
    </main>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    components: {
    },
});
</script>

<style lang="less" scoped>
.main-content{

}
</style>
